import { ApiProperty } from '@nestjs/swagger'

export class ClassRoleResponseDto {
  @ApiProperty({ type: 'string', description: 'ID du rôle' })
  id!: string

  @ApiProperty({ type: 'string', description: 'Code du rôle' })
  code!: string

  @ApiProperty({ type: 'string', description: 'Nom du rôle' })
  name!: string
}
